<div class="header">
  <div class="date-time-container">
    <p style="font-size: x-large; font-family: 'Ubuntu', sans-serif; color: var(--s-primary-color); padding: 12px; margin: 0 ">SyncHPC Access</p>
    <!--<p class="day-date">{{newDate | date:'fullDate'}}</p>
    <p class="header-time">{{newDate | date: 'shortTime'}} {{ newDate | date: 'z' }}</p>
    <p></p>-->
  </div>
  <div class="user-name-icon-container">

    <!--<div class="user-icon-container">
      <span><i class="bi bi-person-circle"></i></span>
    </div>-->
    <!-- right side setting -->

    <button mat-icon-button
            class="iconBtn userIconButton"
            title="UserProfile"
            [matMenuTriggerFor]="userMenu">
      <i class="bi bi-person-fill" style="color: var(--s-primary-color)"></i>
      <i matSuffix class="bi bi-caret-down-fill" style="font-size: large; color: var(--s-primary-color)"></i>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before" class="userMenu">
      <div class="userInfoContainer">
        <div class="userInfoes">
          <i class="bi bi-person userInfoIcon"></i>
          <p class="property">User :&nbsp;</p>
          <p class="propertyValue">{{ currentLoggedInUser }}</p>
        </div>
        <!-- License Validity End -->
        <!--<div class="userInfoes">
          <i class="bi bi-star userInfoIcon"></i>
          <p class="property">Role :&nbsp;</p>
          <p class="propertyValue">Job Operatorrrr</p>
        </div>-->
        <hr />
        <button class="signoutBtn">
          <span aria-hidden="true"
                class="bi bi-shield-lock"
                style="margin-right: 5px; cursor: pointer"></span>Change Password
        </button>
        <hr />
        <button (click)="logOut()" class="signoutBtn">
          <span aria-hidden="true"
                class="bi bi-box-arrow-right"
                style="margin-right: 5px; cursor: pointer"></span>Sign Out
        </button>
      </div>
    </mat-menu>





  </div>
</div>
<div class="flex-grow-1" style="width: 97%; margin-right: 5%; background-color: white; margin: auto" *ngIf="showNewsFlash">
  <ng-marquee duration="30s" [stopOnHover]="true">
    <span *ngFor="let flash of newsFlash" style="color: #714f40; font-weight:bolder">
      <img src="../../../assets/images/syncious/new.gif" />
      {{ flash }}
    </span>
  </ng-marquee>
</div>
<div style="width: 97%; height: 2px; background: var(--s-primary-color); margin: auto "></div>
